module.exports = __webpack_public_path__ + "f054430159008b348c9075a16f4b5431.png";